/**
 * Prime Business Zone — Centralized Motion Tokens & Timing System
 * Architectural, luxury timing curves and standardized durations.
 */

export const easings = {
  // Entrance: Swift deceleration into resting state
  entrance: [0.16, 1, 0.3, 1],
  // Exit: Crisp acceleration out of viewport
  exit: [0.4, 0, 1, 1],
  // Interface state change: Smooth symmetrical standard curve
  standard: [0.4, 0, 0.2, 1],
  // Smooth natural spring
  spring: { type: 'spring', stiffness: 180, damping: 22, mass: 0.8 },
  // Subtle magnetic spring
  magnetic: { type: 'spring', stiffness: 350, damping: 25 },
  // Smooth slow ambient drift
  ambient: { duration: 12, repeat: Infinity, ease: 'easeInOut' }
};

export const durations = {
  instant: 0.12,    // 120ms - Active press, instant tactile feedback
  hover: 0.18,      // 180ms - Button hover, glow shifts, icon translations
  interface: 0.32,  // 320ms - Accordions, dropdowns, tab switches
  reveal: 0.65,     // 650ms - Section scroll reveals, hero subtitles
  hero: 1.10,       // 1100ms - Hero master sequence entry
  staggerGap: 0.07, // 70ms  - Stagger between cards or list items
  routeExit: 0.18,  // 180ms - Previous route clean fade/rise
  routeEntry: 0.34  // 340ms - New route soft fade and rise
};

export const delays = {
  subtle: 0.08,
  short: 0.15,
  medium: 0.28,
  long: 0.45
};

export default {
  easings,
  durations,
  delays
};
